<footer class="gb-footer-minimal bg-base-100 text-base-content/80">
  <div class="container mx-auto px-6 lg:px-10">
    <!-- Mobile bottom clearance (pb-28) keeps the row above checkout's fixed
         total/donate bar; sm+ has no sticky bar, so it tightens back to py-5. -->
    <div
      class="flex flex-col gap-3 pt-5 pb-28 text-xs tracking-wide text-base-content/45 sm:flex-row sm:items-center sm:justify-between sm:py-5"
    >
      <!-- Left: tenant legal line -->
      <p class="m-0">
        &copy; {{ year }} {{ ctx.charity?.name ?? 'Givebrite' }}.
        @if (ctx.charity?.registrationNumber) {
          Registered charity {{ ctx.charity?.registrationNumber }}.
        }
      </p>

      <!-- Right: legal links + secure-checkout microlabel -->
      <div class="flex flex-wrap items-center gap-x-5 gap-y-2">
        <nav class="flex flex-wrap items-center gap-x-5 gap-y-2">
          <a [routerLink]="AppRoutes.page.terms()" class="gb-footer-minimal__link">Terms</a>
          <a [routerLink]="AppRoutes.page.privacy()" class="gb-footer-minimal__link">Privacy</a>
          <!-- TODO(routing): '/page/cookies' is not a registered route -->
          <a routerLink="/page/cookies" class="gb-footer-minimal__link">Cookies</a>
        </nav>

        <span class="hidden h-3.5 w-px bg-base-content/15 sm:block" aria-hidden="true"></span>

        <span class="flex items-center gap-1.5 font-medium text-base-content/50">
          <ui-icon name="lock" [size]="12" [strokeWidth]="2" />
          Secure checkout
        </span>
      </div>
    </div>
  </div>
</footer>
